var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t("managedInstructions.assignedDialog.tableSlotComponents.dueDate", { days: _vm.formatSince(new Date(_vm.item?.dueDate)), }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }